import React, { useState } from 'react';
import Icon from '@hubins/components/IconNew';
import __ from 'localisation';
import Button from '@hubins/components/Button';
import { useMiddleman } from '@hubins/middleman';

type DownloadLinkProps = {
  name: string;
  url: string;
  icon: string;
  small?: boolean;
  onlyIcon?: boolean;
  hideName?: boolean;
}

let urls = new WeakMap();

let blobUrl = blob => {
  if (urls.has(blob)) {
    return urls.get(blob);
  } else {
    let url = URL.createObjectURL(blob);
    urls.set(blob, url);
    return url;
  }
};

const DownloadLink = ({
  name = '',
  url = '',
  icon = 'Common File Stack by Streamlinehq',
  small = false,
  onlyIcon = false,
  hideName = false
}: DownloadLinkProps) => {
  const middleman = useMiddleman();

  const [downloading, setDownloading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const [file, setFile] = useState<Blob | null>(null);

  // Start downloading the raw data when clicking the link
  // e: event
  // name: this.props.name
  const onClickDownload = (e: React.MouseEvent<HTMLButtonElement>, url: string, filename: string) => {
    e.preventDefault();

    setDownloading(true);

    fetch(e, url, filename);
  }

  const saveFile = (url, filename) => {
    var link = document.createElement('a');
    if (typeof link.download === 'string') {
      document.body.appendChild(link); //Firefox requires the link to be in the body
      link.download = filename;
      link.href = url;
      link.click();
      document.body.removeChild(link); //remove the link when done
    } else {
      location.replace(url);
    }
  }

  const fetch = (e, url, filename) => {
    let file: Blob | null = null;

    if (!downloaded) {
      middleman.getBlob(url).then((response) => {
        file = response.data as Blob;
        if (typeof file !== "undefined") {
          
          setDownloaded(true);
          setDownloading(false);
          setFile(file);

          const url = blobUrl(file);
          saveFile(url, filename);
        }
      }).catch(err => {
        console.log("Error fetching file", err);
        setDownloading(false);
      });
    }
    else {
      saveFile(blobUrl(file), filename);
    }
  }

  return (
    <Button
      onClick={(e) => onClickDownload(e, url, name)}
      onlyIcon={onlyIcon}
      className={`${onlyIcon ? '' : ''} ${(!small && !onlyIcon) && 'button withicon withicon--left spacing '}`}
    >
      {hideName ? '' : name}
      {!downloading && !downloaded &&
        <Icon
          icon="Download Bottom by Streamlinehq"
          size={16}
          label={__('download_file') + ': '}
        />
      }
      {downloading && !downloaded &&
        <Icon
          icon="loading"
          size={16}
          label={__('loading')}
        />
      }
      {downloaded &&
        <Icon
          icon={icon}
          color="primary"
          size={16}
          label={__('download_file') + ': '}
        />
      }
    </Button>
  );
}

export default DownloadLink;